<template>
  <!-- is-selected 추가시 드롭다운 보임 -->
  <div class="dropdown-independent OPTION is-selected">
    <div class="w--1200px m--auto">

      <!-- 스토리 -->
      <!-- <div
        class="hospital-nav-container clearfix"
        style="background-image:url(http://remainlab.sshel.com/hospital/MenutabIcon1.png);"
      >
        <div class="col-m-3">
          <span class="hospital__title-deco">연세자연미<strong>스토리</strong></span>
        </div>
        <div class="col-m-9">
          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >의료진 소개</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >병원 둘러보기</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >진료안내</a>
            </div>
          </div>
          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >오시는 길</a>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 안티에이징 -->
      <!-- <div
        class="hospital-nav-container clearfix"
        style="background-image:url(http://remainlab.sshel.com/hospital/MenutabIcon2.png);"
      >
        <div class="col-m-3">
          <span class="hospital__title-deco">연세자연미<strong>안티에이징</strong></span>
        </div>
        <div class="col-m-9">

          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >중년 눈 성형</a>
              <ul>
                <li class="menu-sm"><a href="#">상안검 수술</a></li>
                <li class="menu-sm"><a href="#">하안검 수술</a></li>
                <li class="menu-sm"><a href="#">확장형 하안검 수술</a></li>
                <li class="menu-sm"><a href="#">중안면부거상술</a></li>
                <li class="menu-sm"><a href="#">비절개 눈매교정</a></li>
                <li class="menu-sm"><a href="#">눈썹 거상술</a></li>
              </ul>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >주름 성형</a>
              <ul>
                <li class="menu-sm"><a href="#">귀앞절개 안면 거상술</a></li>
                <li class="menu-sm"><a href="#">이마 거상술</a></li>
                <li class="menu-sm"><a href="#">미간주름 제거</a></li>
                <li class="menu-sm"><a href="#">목주름 교정술</a></li>
                <li class="menu-sm"><a href="#">안면거상 재수술</a></li>
                <li class="menu-sm"><a href="#">반영구 실리프팅</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 눈성형 -->
      <!-- <div
        class="hospital-nav-container clearfix"
        style="background-image:url(http://remainlab.sshel.com/hospital/MenutabIcon3.png);"
      >
        <div class="col-m-3">
          <span class="hospital__title-deco">연세자연미<strong>눈성형</strong></span>
        </div>
        <div class="col-m-9">

          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >쌍커풀</a>
              <ul>
                <li class="menu-sm"><a href="#">비절개</a></li>
                <li class="menu-sm"><a href="#">절개</a></li>
              </ul>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >눈매교정 (안검하수)</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >트임성형</a>
              <ul>
                <li class="menu-sm"><a href="#">앞트임</a></li>
                <li class="menu-sm"><a href="#">뒷트임</a></li>
                <li class="menu-sm"><a href="#">밑트임</a></li>
              </ul>
            </div>
          </div>

          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >눈밑 지방 재배치</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >다크써클 교정</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >쌍커풀 재수술</a>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 쁘띠성형 -->
      <!-- <div
        class="hospital-nav-container clearfix"
        style="background-image:url(http://remainlab.sshel.com/hospital/MenutabIcon4.png);"
      >
        <div class="col-m-3">
          <span class="hospital__title-deco">연세자연미<strong>쁘띠성형</strong></span>
        </div>
        <div class="col-m-9">

          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >반영구 필러</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >미세자가 지방이식</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >보톡스</a>
            </div>
          </div>

          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >TAN박피술</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >흉터성형</a>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 코성형 -->
      <!-- <div
        class="hospital-nav-container clearfix"
        style="background-image:url(http://remainlab.sshel.com/hospital/MenutabIcon5.png);"
      >
        <div class="col-m-3">
          <span class="hospital__title-deco">연세자연미<strong>코성형</strong></span>
        </div>
        <div class="col-m-9">

          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >유형별 코성형</a>
            </div>

          </div>
        </div>
      </div> -->

      <!-- 커뮤니티 -->
      <div
        v-if="menu"
        class="hospital-nav-container clearfix"
        :style="`${menu.route && menu.route.fileName ? 'background-image:url(/api/resources/files/' + menu.route.fileName + ');' : ''}`"
      >
        <div class="col-m-3">
          <span class="hospital__title-deco">{{company.companyName}}<strong :class="themeClasses('dropdownMenu')">{{menu.menuName}}</strong></span>
        </div>
        <div class="col-m-9">

          <div
            class="menu-row clearfix"
            v-for="(chunkMenu, index) in chunkMenus"
            :key="index"
          >
            <div
              class="col-m-4"
              v-for="sub in chunkMenu"
              :key="sub.menuName"
            >
              <a
                @click="menuClick(sub)"
                class="menu-md"
                :class="themeClasses('dropdownMenu')"
              >{{sub.menuName}}</a>
              <ul v-if="sub.children && sub.children.length > 0">
                <li
                  class="menu-sm"
                  v-for="last in sub.children"
                  :key="last.menuName"
                ><a @click="menuClick(last)">{{last.menuName}}</a></li>
              </ul>
            </div>

          </div>
          <!-- 
          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >BEFORE & AFTER</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >네이버 지식인 답변</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >온라인 상담</a>
            </div>
          </div>

          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >전문의 상담</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >방송출현</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >발표 논문</a>
            </div>
          </div>

          <div class="menu-row clearfix">
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >언론 보도 자료</a>
            </div>
            <div class="col-m-4">
              <a
                href="#"
                class="menu-md"
              >수필모음</a>
            </div>
          </div> -->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import theme from '@/component/js/theme'

export default {
  mixins: [theme],
  props: {
    menu: { type: Object },
    menuClick: { type: Function },
    chunk: { type: Number, default: 3 }
  },
  computed: {
    ...mapState(['company']),
    chunkMenus () {
      let i = 0
      let j = this.menu.children.length
      let menus = []
      while (i < j) {
        menus.push(this.menu.children.slice(i, i + this.chunk))
        i += this.chunk
      }
      return menus
    }
  }
}
</script>
